import React, { ReactElement } from 'react';

import { ChangeEvent } from '@philips-emr/tws-core/lib/component/types';

import { Input } from '..';

export interface InputProps {
  enabled?: boolean;
  externalAction?: ReactElement | null;
  onFocus?: (event: FocusEvent) => void;
  placeholder?: string;
  readOnly?: boolean;
  value: string;
}

export function FakeInput({ enabled, externalAction, onFocus, placeholder, readOnly, value }: InputProps): ReactElement {
  return (
    <div className="c-autocomplete__search">
      <Input
        autoComplete="off"
        autoCorrect={false}
        enabled={enabled}
        externalAction={externalAction}
        onFocus={onFocus}
        placeholder={placeholder}
        readOnly={readOnly}
        value={value}
      />
    </div>
  );
}

export interface ModalInputProps extends InputProps {
  onBlur: (event: FocusEvent) => void;
  onChange: (event: ChangeEvent<string>) => void;
}

export function ModalInput({ onBlur, onChange, onFocus, placeholder, value }: ModalInputProps): ReactElement {
  return (
    <div className="c-autocomplete__search">
      <Input
        autoComplete="off"
        autoFocus
        autoSelect
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        placeholder={placeholder}
        tabIndex={1}
        value={value}
      />
    </div>
  );
}
